// extracted by mini-css-extract-plugin
module.exports = {"sectionAmazonPay":"AmazonPayPanel_sectionAmazonPay__S6xdk","tagAmazon":"AmazonPayPanel_tagAmazon__JkOI_","titleBorder":"AmazonPayPanel_titleBorder__CDOJM"};